import { useMemo } from 'react'
import { useQuery } from '@apollo/client'

import { GrantedWebSettingsQuery, GrantedWebSettingsQueryVariables } from 'gql'

import { GRANTED_WEB_SETTINGS } from 'gql/platform/queries'
import { PARTNER_SLUG } from 'constants/constant'

type UseGrantedWebSectionsParams = {
  variables: GrantedWebSettingsQueryVariables
}

const useGrantedWebSections = ({ variables }: UseGrantedWebSectionsParams) => {
  const { data, loading } = useQuery<GrantedWebSettingsQuery, GrantedWebSettingsQueryVariables>(
    GRANTED_WEB_SETTINGS,
    {
      variables: { ...variables, partnerSlug: PARTNER_SLUG },
    }
  )

  const settings = useMemo(
    () => data?.grantedWebSettings.edges[0]?.node || { settings: '{}', sections: [] },
    [data?.grantedWebSettings.edges]
  )

  const parsedSettings = useMemo(
    () => ({
      ...settings,
      settings: JSON.parse(settings.settings),
    }),
    [settings]
  )

  const sections = useMemo(
    () =>
      parsedSettings.sections
        .map((section) => ({
          ...section,
          settings: JSON.parse(section.settings),
        }))
        .filter((section) => section.isVisible)
        .sort((a, b) => {
          const { sections: sectionsOrder } = parsedSettings.settings
          return sectionsOrder.indexOf(Number(a.pk)) - sectionsOrder.indexOf(Number(b.pk))
        }),
    [parsedSettings.sections, parsedSettings.settings]
  )

  return { data: sections, loading }
}

export default useGrantedWebSections
